import {
  RebateAgreementBookingsFetcherQuery,
  RebateAgreementBookingsFetcherQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";
import { selectRebateOverviewForGoals } from "../lib/rebateOverviewUtils";

export const rebateAgreementBookingsQuery = gql`
  query RebateAgreementBookingsFetcher(
    $filter: RebateOverviewFilter!
    $goalIds: [ID!]
  ) {
    rebates {
      rebateOverview(filter: $filter) {
        period
        achieved
        rebateTermCode
        rebateAgreement {
          id
          name
          currencyCode
        }
        criterias {
          id
          name
        }
        goals(ids: $goalIds) {
          id
          targetValue
          validFrom
        }
        reservedBookings(goalIds: $goalIds) {
          bookingNumber
          routeCode
          routePairCode
          departureDate
          departureTime
          vehicleType
          length
          weight
          vehicleRegNumber
          trailerRegNumber
          customerReference
          customerNumber
          customerIndex
          invoiceNumber
          invoicedAmount
          invoiceCurrencyCode
          rebateAmountReserved
        }
      }
    }
  }
`;

export const useRebateAgreementBookings = (
  rebateAgreementNumber: number,
  goalIds: string[]
) => {
  const { loading, error, data } = useQuery<
    RebateAgreementBookingsFetcherQuery,
    RebateAgreementBookingsFetcherQueryVariables
  >(rebateAgreementBookingsQuery, {
    variables: {
      filter: { rebateAgreementNumber },
      // Narrows server side, so reserved bookings are only fetched for these
      // goals rather than every goal on the agreement.
      goalIds,
    },
    // Nothing to show without goal ids, so there is nothing worth fetching.
    skip: !Number.isFinite(rebateAgreementNumber) || goalIds.length === 0,
  });

  const overview = useMemo(
    () =>
      selectRebateOverviewForGoals(data?.rebates.rebateOverview ?? [], goalIds),
    [data, goalIds]
  );

  return {
    loading,
    error,
    overview,
  };
};
